import { ArrowLeftRight, Heart } from 'lucide-react';

/**
 * Clean, symmetrical rounded medical cross (medical plus sign).
 */
export function MedicalCross({
  className = 'w-3.5 h-3.5',
}: {
  className?: string;
}) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path d="M8 3.5C8 2.67 8.67 2 9.5 2h5c.83 0 1.5.67 1.5 1.5V8h4.5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5H16v4.5c0 .83-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5V16H3.5C2.67 16 2 15.33 2 14.5v-5C2 8.67 2.67 8 3.5 8H8V3.5z" />
    </svg>
  );
}

export interface RoleSwitchIconProps {
  role?: 'doctor' | 'patient' | string;
  className?: string;
}

/**
 * Bi-directional role switch arrow icon with an overlay badge:
 * - Healthcare Provider: Red badge with a Medical Plus sign
 * - Patient: Rose badge with a Heart icon
 */
export function RoleSwitchIcon({
  role = 'patient',
  className = 'w-5 h-5',
}: RoleSwitchIconProps) {
  const isDoctor = role === 'doctor';

  return (
    <span className="relative inline-flex items-center justify-center">
      <ArrowLeftRight className={className} />
      {isDoctor ? (
        <span
          className="absolute -bottom-1 -right-1 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-red-600 text-white ring-1.5 ring-white shadow-xs"
          title="Healthcare Provider"
          aria-hidden="true"
        >
          <MedicalCross className="h-2 w-2" />
        </span>
      ) : (
        <span
          className="absolute -bottom-1 -right-1 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-rose-500 text-white ring-1.5 ring-white shadow-xs"
          title="Patient"
          aria-hidden="true"
        >
          <Heart className="h-2 w-2 fill-current" strokeWidth={2.5} />
        </span>
      )}
    </span>
  );
}
